module.exports = __webpack_public_path__ + "img/crm-pic.f3388f4d.gif";